import * as React from "react";
import { motion } from "framer-motion";
import { useSheetContext } from "./context";
import styles from "./styles";
const SheetContent = React.forwardRef(({ children, style, disableDrag, ...rest }, ref) => {
    const { dragProps } = useSheetContext();
    const _dragProps = disableDrag ? undefined : dragProps;
    return (React.createElement(motion.div, { ...rest, ref: ref, className: "react-modal-sheet-content", style: { ...styles.content, ...style }, ..._dragProps }, children));
});
SheetContent.displayName = "SheetContent";
export default SheetContent;
//# sourceMappingURL=sheet-content.js.map